/* Wraps react-bootstrap's breadcrumb component */
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';

Breadcrumb.Item = BreadcrumbItem;

export default Breadcrumb;
